export default "__VITE_ASSET__$uf7yu4q__"